/**
 * 系统管理  角色管理
 */
<template>
  <div class="userbox">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/personal/user' }">账号信息</el-breadcrumb-item>
      <el-breadcrumb-item>修改密码</el-breadcrumb-item>
    </el-breadcrumb>

    <div>
      <el-card class="box-card">
        <div class="box-card-content">
          <!-- <el-steps :active="active" finish-status="success">
            <el-step title="验证身份"></el-step>
            <el-step title="设置新密码"></el-step>
            <el-step title="完成"></el-step>
          </el-steps> -->

          <div>
            <!-- <div v-show="index1" style="margin-left: 20%;margin-top:100px">
              <h5>手机验证码验证：账号 A****01 为确认你本人操作，请完成以下验证</h5>
              <p>手机号码： 157****0019</p>
              <p>
                <el-input v-model="input" placeholder="短信验证码" style="width: 200px"></el-input>
                <el-button type="danger" v-show="smsshow" style="width: 120px" @click="sendSMS">获取验证码</el-button>
                <el-button type="info" v-show="!smsshow" style="width: 120px">已发送({{count}} s)</el-button>
              </p>
              <p style="font-size:12px" v-show="!smsshow"> <i class="el-icon-success" style="color:#67c23a;"></i> <span style="color:#999">验证码已发送到你的手机，3分钟内输入有效，验证码等同于密码，打死也不能告诉别人</span> </p>
            </div> -->
            <div v-show="index2" style="margin-left: 20%;margin-top:100px">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="原密码" prop="opwd" v-if="hasPassword!='false'">
                  <el-input v-model="ruleForm.opwd" show-password ></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="pwd">
                  <el-popover
                    placement="right"
                    width="200"
                    trigger="focus">
                    <!-- 密码规则 -->
                    <ul  class="mgt-xs">
                      <li  v-for="item in pwcheckArr" :key="item" :class="item.statusClass" style="font-size: 14px;">
                        <div  style="display: flex;line-height: 20px;">
                          <div  :class="item.statusIcon" style="font-size: 14px;padding-right: 5px;"></div>
                          <div  class="mgl-xs">{{item.text}}</div>
                        </div>
                      </li>
                    </ul>
                    
                      <el-input slot="reference" v-model="ruleForm.pwd" show-password @input="passwordCheck"></el-input>
                  </el-popover>
                </el-form-item>
                <el-form-item label="再次输入" prop="cpwd">
                  <el-input v-model="ruleForm.cpwd" show-password ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div v-show="index3">
              <el-result icon="success" title="密码修改成功" subTitle="您可以使用新密码登录小象云平台">
                <template slot="extra">
                  <el-button class="next-button" size="medium" @click="logout">重新登录系统</el-button>
                </template>
              </el-result>
            </div>
          </div>
          <div style="text-align: center;" v-show="index2">
            <el-button class="next-button" @click="submit">确定</el-button>
          </div>

        </div>

      </el-card>

    </div>
  </div>
</template>

<script>
//API  
import { password} from '../../api/userMG'

export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if(value.length<8){
          callback(new Error('密码至少8个字符'))
        }
        if(!(/[a-zA-Z]{1,}/.test(value))){
          callback(new Error('密码有至少1个字母(a, b, c...)'))
        }
        if(!(/\d{1,}/.test(value))){
          callback(new Error('有至少1个数字(1, 2, 3...)'))
        }
        if(!(/[A-Z]{1,}/.test(value)) || !(/[a-z]{1,}/.test(value))){
          callback(new Error('包含大写和小写字符'))
        }
        if (this.ruleForm.cpwd !== '') {
          this.$refs.ruleForm.validateField('cpwd');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.pwd) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    };

    return {
      hasPassword: true,
      active: 0,
      smsshow: true,
      count: '',
      // index1: true,
      index2: true,
      index3: false,
      ruleForm: {
        opwd: '',
        pwd: '',
        cpwd: ''
      },
      rules: {
        opwd: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
        ],
        pwd: [ 
        { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' } ],
        cpwd: [
        { required: true, message: '请确认密码', trigger: 'blur' },
        { validator: validatePass2, trigger: 'blur' }]
      },
      pwcheckArr: [
        {statusClass:'error', statusIcon:'zm-icon-dot', text: '有至少8个字符'},
        {statusClass:'error', statusIcon:'zm-icon-dot', text: '有至少1个字母(a, b, c...)'},
        {statusClass:'error', statusIcon:'zm-icon-dot', text: '有至少1个数字(1, 2, 3...)'},
        {statusClass:'error', statusIcon:'zm-icon-dot', text: '包含大写和小写字符'}
      ]
    }
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  watch: {},

  /**
   * 创建完毕
   */

  created() {
    console.log(this.$route.query.flag)
    this.hasPassword = this.$route.query.flag
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    next() {
      if (this.active++ > 2) this.active = 0

      switch (this.active) {
        case 0:
          this.index1 = true
          this.index2 = !this.index1
          this.index3 = !this.index1
          break
        case 1:
          this.index2 = true
          this.index1 = !this.index2
          this.index3 = !this.index2
          break
        case 2:
          this.index3 = true
          this.index2 = !this.index3
          this.index1 = !this.index3
          break
      }
    },
    logout() {
      this.$store.commit('logout',null)
      this.$router.push({ path: '/login' })
    },
    submit(){
      this.$refs['ruleForm'].validate(valid => {
          if(valid){
            const params = {
              oldPassword: this.ruleForm.opwd,
              password: this.ruleForm.pwd
            }
            password(params).then(res=>{
              if(res.code==0){
                this.index2 = false
                this.index3 = true
                if(!hasPassword){
                  let u = this.$store.state.user
                  u.hasPassword = true
                  this.$store.commit('login', u)
                }
              }else{
                this.$message.error(res.message)
              }
            })
          }
      })
      
    },
    passwordCheck(value){
      console.log(value)
      if(value.length>=8){
          this.pwcheckArr[0].statusClass = 'success'
          this.pwcheckArr[0].statusIcon = 'zm-icon-checked'
      }else{
          this.pwcheckArr[0].statusClass = 'error'
          this.pwcheckArr[0].statusIcon = 'zm-icon-dot'
      }
      if(/[a-zA-Z]{1,}/.test(value)){
          this.pwcheckArr[1].statusClass = 'success'
          this.pwcheckArr[1].statusIcon = 'zm-icon-checked'
      }else{
          this.pwcheckArr[1].statusClass = 'error'
          this.pwcheckArr[1].statusIcon = 'zm-icon-dot'
      }
      if(/\d{1,}/.test(value)){
          this.pwcheckArr[2].statusClass = 'success'
          this.pwcheckArr[2].statusIcon = 'zm-icon-checked'
      }else{
          this.pwcheckArr[2].statusClass = 'error'
          this.pwcheckArr[2].statusIcon = 'zm-icon-dot'
      }
      if(/[A-Z]{1,}/.test(value) && /[a-z]{1,}/.test(value)){
          this.pwcheckArr[3].statusClass = 'success'
          this.pwcheckArr[3].statusIcon = 'zm-icon-checked'
      }else{
          this.pwcheckArr[3].statusClass = 'error'
          this.pwcheckArr[3].statusIcon = 'zm-icon-dot'
      }
    }
  }
}
</script>

<style scoped>
.box-card {
  /* width: 100%; */
  margin-top: 20px;
}
.box-card-content {
  width: 80%;
  margin-left: 10%;
}
.next-button {
  margin-top: 80px;
  background-color: rgb(211, 110, 105);
  color: rgb(255, 255, 255);
}

.mgt-xs {
    margin-top: 4px!important;
}
ul{
  
  list-style: none;
    padding-left: 0;

}
.error {
    color: #747487;
}
.zm-icon-dot:before {
    content: "\2022";
}
.zm-icon-checked:before {
    content: "\2714";
}
.success {
    color: #3c763d;
}

</style>

<style >
.el-step__head.is-process .el-step__icon {
  background-color: #d36e69;
  /* color: #fff; */
  /* border-color: tomato; */
}
.el-step__head.is-process {
  color: #fff;
  border-color: #d36e69;
}
.el-step__line {
  margin-right: 5px !important;
  margin-left: 30px;
}
.el-step__title.is-process {
  color: #d36e69;
}
.userbox .el-form .el-input {
  width: 270px;
}
</style>

 


// WEBPACK FOOTER //
// src/views/personal/password.vue